import React from "react";

function Pisces() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.158 496.158"
      enableBackground="new 0 0 496.158 496.158"
    >
      <path
        fill="#58D1DD"
        d="M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
      />
      <g>
        <path
          fill="#C14E00"
          d="M298.486,105.655c-1.959-0.735-50.152-18.669-79.666-17.209
		c-18.338,0.888-31.063,20.819-31.599,21.667c-0.501,0.8-0.573,1.796-0.192,2.659c0.383,0.862,1.168,1.479,2.1,1.645l105.969,18.924
		c0.166,0.03,0.333,0.044,0.499,0.044c0.621,0,1.229-0.203,1.727-0.586c0.635-0.486,1.034-1.217,1.101-2.011l1.894-22.234
		C300.426,107.285,299.676,106.1,298.486,105.655z"
        />
        <path
          fill="#C14E00"
          d="M283.058,233.673l-13.998-31.527c-0.566-1.281-2.048-1.891-3.348-1.39l-50.24,19.25
		c-1.002,0.384-1.672,1.335-1.692,2.407c-0.021,1.071,0.608,2.049,1.592,2.473c1.312,0.563,32.471,13.788,65.386,12.488
		c0.107-0.005,0.211-0.016,0.316-0.033c0.746-0.121,1.41-0.558,1.814-1.208C283.35,235.392,283.414,234.471,283.058,233.673z"
        />
      </g>
      <path
        fill="#E85E00"
        d="M397.451,226.358l-10.256-61.663l10.256-62.25c0.184-1.105-0.52-2.174-1.686-2.564
	s-2.475,0.006-3.141,0.949c-13.955,19.732-39.832,49.62-49.864,49.62c-8.78,0-29.989-11.148-39.31-18.193
	c-19.637-14.841-46.532-26.955-78.326-26.955c-57.056,0-123.479,31.723-126.447,58.422l38.072,14.726l-37.086-6.98
	c8.959,24.991,71.413,54.073,125.461,54.073c35.691,0,67.545-17.124,86.577-32.429c6.176-4.967,22.864-14.757,31.059-14.757
	c9.61,0,35.69,29.896,49.872,49.635c0.498,0.691,1.342,1.083,2.214,1.083c0.311,0,0.626-0.049,0.93-0.152
	C396.937,228.528,397.635,227.46,397.451,226.358z"
      />
      <circle fill="#42423F" cx="166.159" cy="142.019" r="11.852" />
      <circle fill="#FFFFFF" cx="169.229" cy="137.189" r="4.829" />
      <g>
        <path
          fill="#C14E00"
          d="M308.936,280.446c-0.535-0.848-13.261-20.779-31.599-21.667
		c-29.514-1.46-77.707,16.474-79.666,17.209c-1.189,0.445-1.939,1.63-1.831,2.898l1.894,22.234c0.066,0.794,0.466,1.524,1.101,2.011
		c0.497,0.383,1.105,0.586,1.727,0.586c0.166,0,0.333-0.014,0.499-0.044l105.968-18.924c0.932-0.165,1.717-0.782,2.1-1.645
		C309.51,282.242,309.437,281.246,308.936,280.446z"
        />
        <path
          fill="#C14E00"
          d="M280.685,390.34l-50.24-19.25c-1.3-0.501-2.781,0.108-3.348,1.39l-13.998,31.527
		c-0.355,0.798-0.291,1.719,0.17,2.46c0.404,0.65,1.068,1.087,1.814,1.208c0.105,0.017,0.209,0.028,0.316,0.033
		c32.915,1.3,64.074-11.924,65.386-12.488c0.983-0.423,1.612-1.402,1.592-2.473C282.357,391.675,281.687,390.724,280.685,390.34z"
        />
      </g>
      <path
        fill="#E85E00"
        d="M397.48,334.056c-2.968-26.699-69.392-58.422-126.447-58.422c-31.794,0-58.689,12.114-78.326,26.955
	c-9.32,7.045-30.529,18.193-39.31,18.193c-10.032,0-35.909-29.888-49.864-49.62c-0.665-0.943-1.975-1.34-3.141-0.949
	s-1.869,1.459-1.686,2.564l10.256,62.25L98.706,396.69c-0.184,1.103,0.514,2.17,1.675,2.563c0.304,0.104,0.619,0.152,0.93,0.152
	c0.872,0,1.716-0.392,2.214-1.083c14.182-19.738,40.262-49.635,49.872-49.635c8.194,0,24.883,9.79,31.06,14.757
	c19.031,15.305,50.885,32.429,86.576,32.429c54.049,0,116.502-29.082,125.461-54.073l-37.086,6.98L397.48,334.056z"
      />
      <circle fill="#42423F" cx="329.999" cy="312.349" r="11.852" />
      <circle fill="#FFFFFF" cx="326.929" cy="307.519" r="4.829" />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Pisces;
